import React from "react";
import { Routes, Route, Navigate, useLocation, Outlet } from "react-router-dom";
import Layout from "../components/layout";
import Home from "../pages/HomePage";
import CampaignList from "../pages/CampaignList";
import CampaignDetailWrapper from "../pages/CampaignDetailPage/CampaignDetailWrapper";
import CampaignIdRedirect from "../pages/CampaignDetailPage/CampaignIdRedirect";
import CampaignStoryIdRedirect from "../pages/CampaignDetailPage/CampaignStoryIdRedirect";
import ContactUsPage from "../pages/ContactUsPage";
import AboutUsPage from "../pages/AboutUsPage";
import WhoWeAre from "../pages/AboutUsPage/whoWeAre";
import Blogs from "../pages/Blogs";
import BlogDetails from "../pages/Blogs/BlogDetails";
import StartNewCampaign from "../pages/StartNewCampaign";
import MonthlyDonation from "../pages/MonthlyDonation";
import Profile from "../pages/Profile";
import MyProfile from "../pages/Profile/MyProfile";
import DonateOnce from "../pages/Profile/DonateOnce";
import DonateMonthly from "../pages/Profile/DonateMonthly";
import MyTransactions from "../pages/Profile/MyTransactions";
import Subscriptions from "../pages/Profile/Subscriptions";
import Download80GForm from "../pages/Profile/Download80GForm";
import Download10BForm from "../pages/Profile/Download10BForm";
import Form80G from "../pages/Profile/Form80G";
import Form10B from "../pages/Profile/Form10B";
import OverseasDonation from "../pages/Profile/OverseasDonation";
import MonthlyDonationDetail from "../pages/MonthlyDonationDetailPage";
import SearchResults from "../pages/SearchResults";
import LifePage from "../pages/LifePage";
import LifeDetailPage from "../pages/LifeDetailPage/LifeDetailPage";
import SmallVendors from "../pages/SmallVendors";
import TemplesPage from "../pages/Temples";
import SmallVendorsDetailPage from "../pages/SmallVendorsDetailPage";
import SmallVendorsPaymentPage from "../pages/SmallVendorsPaymentPage";
import DocumentsPage from "../pages/DocumentsPage";

// Responsive Authentication Wrapper
import ResponsiveAuthWrapper from "../components/common/ResponsiveAuthWrapper";

// Authentication Pages (for separate routes)
import ResetPasswordPage from "../pages/AutenticationPages/ResetPasswordPage";

// Policy Pages
import PrivacyPolicy from "../pages/privacy-policys";
import TermsAndConditions from "../pages/Terms&Condition";
import RefundCancellation from "../pages/Refund&Cancellation";
import ReturnPolicy from "../pages/ReturnPolicy";
import { useSelector } from "react-redux";

// Require authentication for protected routes (e.g., profile pages)
const RequireAuth = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect unauthenticated users to login, preserving the intended destination
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};
import Faq from "../pages/Faq";

// Donation pages
import DonateOncePage from "../pages/DonateOncePage";
import DonateMonthlyPage from "../pages/DonateMonthlyPage";
import DonateProductPage from "../pages/DonateWithProductPage";
import OverseasDonorPage from "../pages/OverseasDonorPage";
import ThankyouPage from "../pages/ThankyouPage";
import PaymentFailurePage from "../pages/PaymentFailurePage";
import NotFoundPage from "../pages/NotFoundPage";

const MainRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* Home Route */}
        <Route index element={<Home />} />

        {/* Campaign Routes */}
        <Route path="campaigns" element={<CampaignList />} />
        {/* Backward compatibility: Old ID-based URLs - redirect to new slug format */}
        <Route path="campaigns/:id" element={<CampaignIdRedirect />} />
        <Route path="story/campaigns/:id" element={<CampaignStoryIdRedirect />} />
        {/* New redirects-based routes */}
        <Route path="story/:slug" element={<CampaignDetailWrapper />} />
        <Route path="campaign/:slug" element={<CampaignDetailWrapper />} />
        <Route path="start-campaign" element={<StartNewCampaign />} />
        <Route path="search" element={<SearchResults />} />
        {/* Donation Specific Routes */}
        <Route path="donate-once-page" element={<DonateOncePage />} />
        <Route path="donate-monthly-page" element={<DonateMonthlyPage />} />
        <Route path="donate-product-page" element={<DonateProductPage />} />
        <Route path="overseas-donor-page" element={<OverseasDonorPage />} />
        <Route path="thankyou-Page" element={<ThankyouPage />} />
        <Route path="Monthly/thankyou-Page" element={<ThankyouPage />} />
        <Route path="payment-failure" element={<PaymentFailurePage />} />
        {/* Blog Routes */}
        <Route path="blogs" element={<Blogs />} />
        <Route path="blog/:id" element={<BlogDetails />} />

        {/* About Us Routes */}
        <Route path="about" element={<AboutUsPage />} />
        <Route path="about/who-we-are" element={<WhoWeAre />} />

        {/* Life Routes: /life = list with Life cards, /life/:slug = life detail page */}
        <Route path="life" element={<Outlet />}>
          <Route index element={<LifePage />} />
          <Route path=":slug" element={<LifeDetailPage />} />
        </Route>

        {/* Monthly Donation Routes */}
        <Route path="monthly-donation" element={<MonthlyDonation />} />
        <Route path="small-vendors" element={<SmallVendors />} />
        <Route path="temples" element={<TemplesPage />} />
        <Route path="documents" element={<DocumentsPage />} />
        <Route path="small-vendors/detail" element={<SmallVendorsDetailPage />} />
        <Route path="small-vendors/detail/:id" element={<SmallVendorsDetailPage />} />
        <Route path="small-vendors/:slug" element={<SmallVendorsDetailPage />} />
        <Route path="small-vendors/payment/:id" element={<SmallVendorsPaymentPage />} />
        <Route
          path="monthly-donation-detail"
          element={<MonthlyDonationDetail />}
        />

        {/* Contact Route */}
        <Route path="contact" element={<ContactUsPage />} />

        {/* Profile Routes (protected) */}
        <Route path="profile" element={<RequireAuth><Profile /></RequireAuth>}>
          <Route index element={<MyProfile />} />
          <Route path="my-profile" element={<MyProfile />} />
          <Route path="donate-once" element={<DonateOnce />} />
          <Route path="donate-monthly" element={<DonateMonthly />} />
          <Route path="overseas-donation" element={<OverseasDonation />} />
          <Route path="my-transactions" element={<MyTransactions />} />
          <Route path="subscriptions" element={<Subscriptions />} />
          <Route path="80g-forms" element={<Form80G />} />
          <Route path="10b-forms" element={<Form10B />} />
        </Route>

        {/* Download Forms - Separate Pages (also protected) */}
        <Route
          path="profile/download-80g-form"
          element={
            <RequireAuth>
              <Download80GForm />
            </RequireAuth>
          }
        />
        <Route
          path="profile/download-10b-form"
          element={
            <RequireAuth>
              <Download10BForm />
            </RequireAuth>
          }
        />

        {/* Authentication Routes (Responsive) */}
        <Route
          path="login"
          element={<ResponsiveAuthWrapper initialView="login" />}
        />
        <Route
          path="register"
          element={<ResponsiveAuthWrapper initialView="register" />}
        />
        <Route
          path="forgot-password"
          element={<ResponsiveAuthWrapper initialView="forgot" />}
        />
        <Route
          path="verification"
          element={<ResponsiveAuthWrapper initialView="verify" />}
        />

        {/* Reset Password Routes (Separate) */}
        <Route path="reset-password" element={<ResetPasswordPage />} />

        {/* Policy Routes */}
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="terms-conditions" element={<TermsAndConditions />} />
        <Route path="refund-cancellation" element={<RefundCancellation />} />
        <Route path="return-policy" element={<ReturnPolicy />} />
        <Route path="faq-page" element={<Faq />} />

        {/* Legacy Routes for backward compatibility */}
        <Route path="terms&Conditions" element={<TermsAndConditions />} />
        <Route path="refund&cancellation" element={<RefundCancellation />} />
        {/* NOTE:
          - 10B form stays PUBLIC (legacy behavior).
          - 80G form requires login: opening the email link in a fresh browser
            redirects to /login and returns here (query params intact) after success.
        */}
        <Route path="profile/80g-form" element={<RequireAuth><Download80GForm /></RequireAuth>} />
        <Route path="profile/10b-form" element={<Download10BForm />} />
      </Route>
      {/* 404 route outside Layout to avoid header/footer */}
      <Route path="/404" element={<NotFoundPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default MainRoutes;
